import { useEffect, useState } from "react";
import "../CheckOutPage/CheckOut.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import logo from "./AiPayLogo.jpg";
import { baseUrl } from "../../Config";

const CheckOutPage = () => {
  const [responseData, setResponseData] = useState("");
  const navigate = useNavigate();

  const { id } = useParams();

  const validatePayment = async () => {
    try {
      const res = await axios.post(`${baseUrl}api/Merchant/Payment/${id}`);
      const resData = res?.data?.data;

      if (resData) {
        setResponseData(resData);
        localStorage.setItem("checkoutresponse", JSON.stringify(resData));
      } else {
        const responseMessage = res?.data?.message || "Unknown error occurred.";
        navigate("/error", { state: { responseMessage } });
      }
    } catch (error) {
      navigate("/error", {
        state: { responseMessage: "Server error or network issue." },
      });
    }
  };

  useEffect(() => {
    if (id) {
      validatePayment();
    }
  }, [id]);

  return (
    <>
      <div className="checkout-container">
        <div className="checkout-card">
          <div className="checkout-form-section">
            <form action={responseData?.postTransactionUrl} method="POST">
              {responseData?.brandImage && (
                <img
                  className="AiPay-Logo"
                  src={responseData.brandImage}
                  alt="brand-logo"
                />
              )}
              <h2 className="form-heading">Checkout</h2>

              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Currency Code</label>
                  <input
                    readOnly
                    id="CURRENCY_CODE"
                    name="CURRENCY_CODE"
                    value={responseData?.currency}
                    className="form-input"
                  />
                </div>
                <div className="form-field">
                  <label className="form-label">Basket ID</label>
                  <input
                    readOnly
                    id="BASKET_ID"
                    name="BASKET_ID"
                    value={responseData?.basketId}
                    className="form-input"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Transaction Amount</label>
                  <input
                    readOnly
                    id="TXNAMT"
                    name="TXNAMT"
                    value={responseData?.amount}
                    className="form-input"
                  />
                </div>
                <div className="form-field">
                  <label className="form-label">Order Date</label>
                  <input
                    readOnly
                    id="ORDER_DATE"
                    name="ORDER_DATE"
                    value={
                      responseData?.orderDate
                        ? dayjs(responseData?.orderDate).format("YYYY-MM-DD")
                        : ""
                    }
                    className="form-input"
                  />
                </div>
              </div>

              {/* Hidden Inputs */}
              <input
                type="hidden"
                name="MERCHANT_ID"
                value={responseData?.merchantId}
              />
              <input
                type="hidden"
                name="MERCHANT_NAME"
                value={responseData?.merchantName}
              />
              <input
                type="hidden"
                name="TOKEN"
                value={responseData?.accesS_TOKEN}
              />
              <input
                type="hidden"
                name="SUCCESS_URL"
                value={responseData?.successUrl}
              />
              <input
                type="hidden"
                name="FAILURE_URL"
                value={responseData?.failureUrl}
              />
              <input
                type="hidden"
                name="CHECKOUT_URL"
                value={responseData?.checkoutUrl}
              />
              <input
                type="hidden"
                name="CUSTOMER_EMAIL_ADDRESS"
                value={responseData?.customerEmail}
              />
              <div className="form-submit-container">
                <button type="submit" className="search-button">
                  Submit
                </button>
              </div>
            </form>
          </div>

          <div className="checkout-side-panel">
            <img src={logo} alt="AIPAY Logo" className="checkout-logo-side" />
            <h1>EK</h1>
            <h2>Secure Checkout</h2>
            <p>Your transaction is encrypted and safe.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckOutPage;
